(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
   const swiperEl = document.getElementById('related-collection-slider');
   Object.assign(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      pagination: {
         type: 'progressbar',
      },
   });
   swiperEl.initialize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
   const swiperEl = document.getElementById('related-blog-slider');
   Object.assign(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: {
         enabled: true,
         minimumVelocity: 0.01,
         momentumBounce: false,
         sticky: true,
      },
      pagination: {
         type: 'progressbar',
      },
      breakpoints: {
         768: {
            spaceBetween: 64,
         },
         1600: {
            spaceBetween: 92,
         },
         1800: {
            spaceBetween: 160,
         },
      },
   });
   swiperEl.initialize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-stories"] && !Shopify.designMode) return;
  try {
    
   const swiperEl = document.getElementById('related-story-slider');
   Object.assign(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: {
         enabled: true,
         minimumVelocity: 0.01,
         momentumBounce: false,
         sticky: true,
      },
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      pagination: {
         type: 'progressbar',
      },
      breakpoints: {
         768: {
            spaceBetween: 64,
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,
         },
         1600: {
            spaceBetween: 92,
            slidesOffsetBefore: 46,
            slidesOffsetAfter: 46,
         },
         1800: {
            spaceBetween: 160,
            slidesOffsetBefore: 80,
            slidesOffsetAfter: 80,
         },
      },
   });
   swiperEl.initialize();

  } catch(e) { console.error(e); }
})();
})();
